export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/a70fe28c30edbe909cade8425716fdee.svg";